import * as React from "react";
import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import SuiButton from "components/SuiButton";
import ClipLoader from "react-spinners/ClipLoader";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export function SimplePrompt({ promptConfig, setPromptConfig }) {
  const [config, setConfig] = useState({});
  const [open, setOpen] = useState(promptConfig);
  useEffect(() => {
    if (promptConfig) {
      setOpen(true)
      setConfig(promptConfig)
    }
  }, [promptConfig]);

  const closeDialog = () => {
    setOpen(false)
    setPromptConfig(null)
    if (config.handleCancel)
      config.handleCancel()
  }

  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {config.heading}
        <IconButton
          aria-label="close"
          onClick={closeDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{config.text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <SuiButton
          onClick={closeDialog}
          color={config.cancelColor ? config.cancelColor : "secondary"}
          variant="gradient"
        >
          {config.cancelText ?? 'Cancel'}
        </SuiButton>
        <SuiButton
          onClick={() => { closeDialog(); config.handleOk() }}
          autoFocus
          color={config.okColor ? config.okColor : "dark"}
          variant="gradient"
        >
          {config.okText ?? 'OK'}
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
}

export default function Prompt({
  heading,
  text,
  cancelText = "Cancel",
  okText = "Ok",
  okColor,
  cancelColor,
  visible,
  handleClose,
  handleOk,
  loading = false,
  hideAction = false,
  option = {},
}) {
  return (
    <Dialog
      open={visible}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...option}
    >
      <DialogTitle id="alert-dialog-title">
        {heading}
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
      </DialogContent>
      {hideAction ? null : (
        <DialogActions>
          <SuiButton
            onClick={handleClose}
            color={cancelColor ? cancelColor : "secondary"}
            variant="gradient"
          >
            {cancelText}
          </SuiButton>
          <SuiButton
            onClick={handleOk}
            autoFocus
            color={okColor ? okColor : "dark"}
            variant="gradient"
          >
            {loading ? (
              <ClipLoader
                size={18}
                color={okColor ? okColor : "#000000"}
                cssOverride={{ marginRight: 1 }}
              />
            ) : null}
            <div>{okText}</div>
          </SuiButton>
        </DialogActions>
      )}
    </Dialog>
  );
}
